import classNames from 'classnames';

import { ArrowLeft, ArrowRight } from 'components/Icons';

import styles from './styles.module.scss';

export const NavButtonLeft = ({ handlePrev, className = '' }) => (
  <button className={classNames(styles.navBtn, className)} onClick={handlePrev}>
    <ArrowLeft className={styles.arrowLeftIcon} color="#747475" />
  </button>
);

export const NavButtonRight = ({ handleNext, className = '' }) => (
  <button className={classNames(styles.navBtn, className)} onClick={handleNext}>
    <ArrowRight className={styles.arrowRightIcon} color="#747475" />
  </button>
);
